import Interweave from 'interweave'
import PropTypes from 'prop-types'
import React from 'react'
import { convertMdToHtml } from '..'
import Section from '../../Section'

const parseTableFormat = data => {
  const lines = data
    .split('\n')
    .map(line => line.trim())
    .filter(
      line => line.startsWith('|') && !/^[-+| ]+$/.test(line), // skip separator lines
    )

  if (lines.length === 0) return ''

  const rows = lines.map(line =>
    line
      .slice(1, -1) // Remove outer pipes
      .split('|')
      .map(cell => cell.trim()),
  )

  const header = rows[0]
  const bodyRows = rows.slice(1)

  const html = `
    <table>
      <thead>
        <tr>${header.map(cell => `<th>${cell}</th>`).join('')}</tr>
      </thead>
      <tbody>
        ${bodyRows.map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`).join('')}
      </tbody>
    </table>
  `
  return html
}

const CodeCoverage = ({ report: { reportContent } }) => {
  const { codeCoverageOutput, codeCoverageSummary } =
    reportContent.breakdownAndAutomatedAnalysis || {}

  const renderedSummary = codeCoverageSummary ? (
    <Interweave content={convertMdToHtml.makeHtml(codeCoverageSummary)} />
  ) : null

  const renderedTable = codeCoverageOutput ? (
    <div className="coverage-table-container mt-4">
      <Interweave content={parseTableFormat(codeCoverageOutput)} />
    </div>
  ) : null

  return (
    <Section title="Code Coverage">
      {renderedSummary}
      {renderedTable}
    </Section>
  )
}

CodeCoverage.propTypes = {
  report: PropTypes.object,
}

export default CodeCoverage
